@if (hasError === true) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (hasError === false) {
  <div class="grid-container">
    @if(showDownload) {
      <div class="grid-x grid-margin-x">
        <div class="dialog-hint cell small-12 large-12">
          <dialog-hint clickTarget="download" [textkey]="textkeyPrefix + '.callout'" [closable]="true"></dialog-hint>
        </div>
      </div>
    }
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 large-offset-1 large-10 result text-center">
        <h1 [innerHTML]="textkeyPrefix + '.headline.result' | translate"></h1>
        <div class="cell small-12 resultimage-wrapper">
          <i id="icon-tec" class="cell medium-4" [class]="'icon-tec-' + anfrage?.result?.placeholder?.thermostat_type"></i>
          <p id="bubble-1" class="bubble cell medium-4" [innerHTML]="textkeyPrefix + anfrage?.result?.placeholder?.textkey_replace | translate"></p>
          <p id="bubble-2" class="bubble cell medium-4" [innerHTML]="textkeyPrefix + anfrage?.result?.placeholder?.textkey_recommend | translate"></p>
        </div>
      </div>
    </div>
    @if (anfrage?.result?.placeholder?.thermostat_type === 'manuell') {
      <div class="cell small-12 large-10 hint">
        <i class="icon-shiny-lightbulb"></i>
        <p [innerHTML]="textkeyPrefix + '.hint' | translate"></p>
      </div>
    }
    <div class="cell small-12 large-10 thermostat-types">
      <h2 class="text-center" [innerHTML]="textkeyPrefix + '.headline.thermostat.types' | translate"></h2>
      <mat-tab-group mat-align-tabs="start">
        @for (type of thermostatTypes; track type) {
          <mat-tab>
            <ng-template mat-tab-label>
              <i [class]="type === 'info' ? 'icon-information' : 'icon-tec-' + type"></i>
              <span [innerHTML]="textkeyPrefix + '.' + type + '.headline' | translate"></span>
            </ng-template>
            <div class="content">
              <p [class]="type === 'info' ? 'text info' : 'text'" [innerHTML]="textkeyPrefix + '.' + type + '.text' | translate"></p>
              @if (internalPortal === true && type === 'programmierbar') {
                <p class="recommendation" [innerHTML]="textkeyPrefix + '.' + type + '.recommendation' | translate"></p>
              }
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
    @if (internalPortal !== true) {
      <div class="grid-x grid-margin-x roadmap">
        <div class="cell small-12 large-offset-1 large-10 text-center">
          <h2 [innerHTML]="textkeyPrefix + '.headline.roadmap' | translate"></h2>
          <app-advisor-image class="show-for-small-only" path="/tec/tec-roadmap-small.svg" [altText]="textkeyPrefix + '.roadmap.alt_text' | translate" [ariaDescription]="'roadmap-description'"></app-advisor-image>
          <app-advisor-image class="show-for-medium-only" path="/tec/tec-roadmap-medium.svg" [altText]="textkeyPrefix + '.roadmap.alt_text' | translate" [ariaDescription]="'roadmap-description'"></app-advisor-image>
          <app-advisor-image class="show-for-large" path="/tec/tec-roadmap-large.svg" [altText]="textkeyPrefix + '.roadmap.alt_text' | translate" [ariaDescription]="'roadmap-description'"></app-advisor-image>
          <p id="roadmap-description" class="sr-only">{{ textkeyPrefix + '.roadmap.description' | translate }}</p>
        </div>
      </div>
    }
    <div class="replace-tec">
      <h2 class="text-center" [innerHTML]="textkeyPrefix + '.headline.replace.steps' | translate"></h2>
      <ol class="cell small-12 large-10 replace-steps" >
        @for (step of anfrage?.result?.placeholder?.replace_steps; track step) {
          <li><p [innerHTML]="textkeyPrefix + '.replace.step' + step | translate"></p></li>
        }
      </ol>
      @if (internalPortal === true) {
        <div class="cell small-12 large-10 replace-info">
          <i class="icon-information"></i>
          <p [innerHTML]="textkeyPrefix + '.replace.info' | translate"></p>
        </div>
      }
    </div>
    <div class="cell small-12 large-10 hint">
      <i class="icon-shiny-lightbulb"></i>
      <p [innerHTML]="textkeyPrefix + '.hint2' | translate"></p>
    </div>
    @if (anfrage?.result?.placeholder?.tipps?.length > 0) {
      <section class="tipps-wrapper">
        <h2 class="text-center" [innerHTML]="textkeyPrefix + '.tipps.headline' | translate"></h2>
        <app-tipps-slider [tipps]="anfrage?.result?.placeholder?.tipps" [hideButton]="!internalPortal" textPrefix="thermostatcheck.tipps"></app-tipps-slider>
      </section>
    }
    @if (showDownload) {
      <div class="grid-x grid-margin-x" id="thermostatcheck-download">
        <div class="cell small-12">
          <app-download id="download" [url]="reportUrl" textkeyPrefix="thermostatcheck.ergebnis."></app-download>
        </div>
      </div>
    }
    @if (hecUrl) {
      <app-advisor-teaser [url]="hecUrl" [mailUrl]="hecUrl" textPrefix="thermostatcheck.ergebnis.teaser" image="/tec/hec-teaser.svg" changeColumnOrder="true"></app-advisor-teaser>
    }
    <app-portal-teaser></app-portal-teaser>
    @if (internalPortal === true) {
      <app-donate textkeyPrefix="thermostatcheck"></app-donate>
    }
  </div>
}

@if (hasError === false) {
  <div class="grid-x grid-padding-x">
    <div class="cell">
      <app-step-buttons previousLink="../../eingabe/basisdaten/4"
        mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
    </div>
  </div>
}
